import React from 'react';
import { animated, useSpring } from '@react-spring/web';
import { LoadingOvalIcon, LogoutIcon } from '@pushpay/iconography';
import { Menu } from '@pushpay/menu';
import { createUseStyles } from '@pushpay/styles';
import { wait } from '@pushpay/utils';
export const useStyles = createUseStyles(theme => ({
  icon: {
    height: theme.SPACING.LARGE_ICON_SIZE,
    width: theme.SPACING.LARGE_ICON_SIZE
  }
}));
export const Logout = ({
  className,
  classes: classesProp,
  'data-pp-at-target': targetId,
  isLoggingOut = false,
  label,
  onLogout
}) => {
  const classes = useStyles(classesProp);
  const {
    dots
  } = useSpring({
    from: {
      dots: 0
    },
    to: async next => {
      await next({
        dots: 3
      });
      await wait(200);
    },
    config: {
      duration: 1000
    },
    loop: true
  });
  const itemLabel = React.useMemo(() => {
    if (isLoggingOut) {
      return /*#__PURE__*/React.createElement("span", null, label, /*#__PURE__*/React.createElement(animated.span, null, dots.to(d => new Array(Math.round(d)).fill('.').join(''))));
    }

    return /*#__PURE__*/React.createElement("span", null, label);
  }, [dots, isLoggingOut, label]);
  return /*#__PURE__*/React.createElement(Menu.Item, {
    children: null // eslint-disable-line
    ,
    className: className,
    "data-pp-at-target": targetId,
    disableSelection: isLoggingOut,
    displayStyle: "unstyled",
    itemValue: label,
    label: itemLabel,
    leftElement: isLoggingOut ? /*#__PURE__*/React.createElement(LoadingOvalIcon, {
      className: classes.icon,
      "data-pp-at-target": `${targetId}-icon`
    }) : /*#__PURE__*/React.createElement(LogoutIcon, {
      className: classes.icon,
      "data-pp-at-target": `${targetId}-icon`
    }),
    onClick: onLogout
  });
};